import { addToCart } from "./add-to-cart";
import GDropdown from "./g-dropdown";

class ProductStateSelector extends GDropdown {
  static observedAttributes = ["data-line-item-variant-id"];

  constructor() {
    super();

    this._lineItemVariantId = Number.parseInt(this.dataset.lineItemVariantId);
    this._inventoryQuantities = JSON.parse(this.querySelector(".js-inventory-qnt").innerHTML);
  }

  set value(value) {
    const prevValue = this._input.value;
    super.value = value;

    if (prevValue != value) {
      clearTimeout(this._cartUpdateTimeout);
      this._cartUpdateTimeout = setTimeout(this._updateCart.bind(this), 1000);
    }
  }

  get value() {
    return Number.parseInt(super.value);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    switch (name) {
      case "data-line-item-variant-id":
        this._lineItemVariantId = Number.parseInt(newValue);
    }
  }

  async _updateCart() {
    document.dispatchEvent(new CustomEvent("theme:loading:start"));
    try {
      const cart = await (await fetch("/cart.js")).json();

      await fetch("/cart/clear.js", {
        method: "POST",
      });

      const existingVariant = cart.items.find((item) => item.variant_id == this.value);

      const newCartItems = cart.items
        .filter((item) => item.variant_id !== this.value)
        .map((item) => {
          if (item.variant_id === this._lineItemVariantId) {
            let qnt = item.quantity;
            if (existingVariant) qnt += existingVariant.quantity;
            return {
              id: this.value,
              quantity: Math.min(qnt, this._inventoryQuantities[this.value]),
              properties: item.properties || {},
            };
          } else {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties || {},
            };
          }
        })
        .reverse();

      const json = await addToCart(newCartItems, {
        scrollToTop: false,
        manageLoading: false,
      });

      if (json) {
        this.dataset.lineItemVariantId = this.value;
      }
    } catch (error) {
      console.error("Error updating the cart:", error);
    } finally {
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  }
}

if (!customElements.get("product-state-selector")) {
  customElements.define("product-state-selector", ProductStateSelector);
}
